<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { getAppConfig } from '../../../common/config/app-config';
  import { productDetailMainData } from '../store/pdp_store';
  import PdpPriceAlert from './PdpPriceAlert.svelte';
  import PdpPurchaseCta from './PdpPurchaseCTA.svelte';
  let innerWidth = window.innerWidth;

  export let data: any;
  const { priceAlertEnabled } = getAppConfig();

  /**
   * Calculates the flag to disable the pre-order button based on the stock levels.
   */

  let dispatcher = createEventDispatcher();

  function onKeydown(event) {
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'f') {
      event.preventDefault();
    }
  }
</script>

<svelte:window on:keydown={onKeydown} bind:innerWidth />
{#if data?.stock.stockLevelStatus.code === 'inStock' || data?.stock.stockLevelStatus.code === 'lowStock' || data?.productStatus === 'PRE_ORDER'}
  <section class="parent-div">
    <div class={innerWidth <= 900 ? 'padd_desk' : 'padd_mob'}>
      <PdpPurchaseCta {data} on:addToCart={() => dispatcher('addToCart')} />
      {#if !data?.isDigitalGiftCard && !$productDetailMainData.isMarketPlaceProduct && priceAlertEnabled}
        <div class="extra-btn-action-wrapper" style={innerWidth < 900 ? 'display:none' : ''}>
          <div class="content d-flex justify-content-center">
            {#if data?.productStatus !== 'PRE_ORDER'}
              <PdpPriceAlert productCode={data?.productCode} />
            {/if}
          </div>
        </div>
      {/if}
    </div>
  </section>
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .parent-div {
    // max-width: 522px;
    max-width: 100%;
    padding-top: 30px;
    padding-bottom: 6px;

    .extra-btn-action-wrapper {
      .content {
        margin-top: 30px;
        gap: 36px;
        padding-bottom: 29px;
      }
    }
  }
  @include desktop-max-width {
    .parent-div {
      background-color: $primary-white;
      position: sticky;
      bottom: 0;
      box-shadow: 0px -8px 12px transparentize($secondary-gray-02, (1 - 0.32));
      padding-top: 0px;
      padding-bottom: 0px;
      .mdc-typography--body2 {
        font-size: 14px;
        line-height: 16px;
        text-transform: capitalize;
        white-space: nowrap;
      }
    }
  }
  .padd {
    &_desk {
      padding: 24px 16px;
    }

    &-mob {
      padding: 48px 0 29px 0;
    }
  }

  .cur-weight {
    font-weight: 400;
  }
</style>
